// Internal dep.
import webAPIUtils from "../utils/WebAPIUtils";
import logger from "../utils/LoggerFrontend";
import database from "../utils/FirebaseController";
// Module
export default function (Actions) {
  function createCommentInDatabase(data, callback) {
    logger.debug("Actions:CommentSystem:createCommentInDatabase", "called...", data);

    database
      .createComment(data)
      .then((snapshot) => {
        // Increment user nrOfComments
        data &&
          data.userId &&
          database.incrementNrOfComments(data.userId).then((snapshot) => {
            logger.debug("Actions:CommentSystem:createCommentThen", "success", snapshot);
            // Succesful
          });

        callback(undefined, snapshot);
      })
      .catch((err) => {
        logger.log("error:Actions:CommentSystem:createCommentInDatabase", "error...", {
          err,
          data
        });
        callback(err);
      });
  }

  //---------------------------------------------------------------------------
  // Method
  //---------------------------------------------------------------------------
  Actions.storeCommentWithoutEmailAndNotification.listen(function (
    orgaId,
    campaignId,
    comment,
    userName,
    userrole,
    userId,
    meta
  ) {
    logger.log("Actions:CommentSystem:storeCommentWithoutEmailAndNotification", "↪ called...", {
      orgaId,
      campaignId,
      comment,
      userName,
      userrole,
      userId,
      meta
    });
    meta.campaignManager = meta.campaignManager || "diana";

    const data = {
      userName: userName || "",
      createDate: +new Date(),
      comment,
      userrole: userrole || "member", // admin or member
      userId: userId || "",
      orgaId,
      campaignId,
      meta: meta || {}
    };

    logger.log("Actions:CommentSystem:storeCommentWithoutEmailAndNotification", "↪ ... test", data);

    createCommentInDatabase(data, (err, commentData) => {
      if (err) {
        logger.log(
          "error:Actions:CommentSystem:storeCommentWithoutEmailAndNotification:then",
          "err ",
          { err, data }
        );
        return this.failed(err);
      }

      const commentId = commentData.id;

      logger.debug(
        "Actions:CommentSystem:storeCommentWithoutEmailAndNotification:then",
        "commentId ",
        { commentId, data }
      );

      this.completed(orgaId, campaignId, comment, userName, userrole, userId, commentId, meta);
    });
  });
  //---------------------------------------------------------------------------
  // Method
  //---------------------------------------------------------------------------
  Actions.storeComment.listen(function (
    orgaId,
    campaignId,
    comment,
    userName,
    userrole,
    userId,
    meta
  ) {
    const data = {
      userName,
      comment,
      userrole, // admin or enduser
      orgaId,
      campaignId,
      userId: userId || "",
      createDate: +new Date(),
      meta: meta || {}
    };

    logger.debug("Actions:CommentSystem:storeComment", "↪ called...", data);

    createCommentInDatabase(data, (err, commentData) => {
      if (err) {
        logger.log("error:Actions:CommentSystem:storeComment:then", "err ", { err, commentData });
      }

      const commentId = commentData && commentData.id;

      if (!commentId) {
        logger.log("error:Actions:CommentSystem:storeComment:then", "No comment id ", commentId);
      }

      logger.debug("Actions:CommentSystem:storeComment:then", "called...commentData: ", commentId);

      const dataNotification = {
        id: commentId || "",
        message: comment,
        userrole,
        campaignId,
        orgaId,
        username: userName || "-",
        userId: userId || "-",
        meta: meta || {}
      };

      webAPIUtils.newComment(orgaId, campaignId, dataNotification);

      this.completed(orgaId, campaignId, comment, userName, userrole, userId, commentId, meta);
    });
  });
  //---------------------------------------------------------------------------
  // Method
  //---------------------------------------------------------------------------
  Actions.deleteComment.listen(function (orgaId, campaignId, commentId) {
    logger.debug("Actions:CommentSystem:deleteComment", "↪ called...", {
      orgaId,
      campaignId,
      commentId
    });
    database
      .deleteComment(orgaId, campaignId, commentId)
      .then(() => {
        webAPIUtils.notifiyEvent(orgaId, campaignId, {
          // eventName: "comments",
          // text: `⛔️ Kommentar *${commentId}* wurde gelöscht`
          eventName: "comment-deleted",
          eventStatus: "start",
          text: `⛔️ Kommentar *${commentId}* wurde gelöscht`,
          orgaId,
          campaignId,
          campaignManager: "",
          userName: ""
        });

        this.completed(orgaId, campaignId, commentId);
      })
      .catch(this.failed);
  });

  //---------------------------------------------------------------------------
  // Method
  //---------------------------------------------------------------------------
  Actions.fetchAllComments.listen(function (orgaId, campaignId) {
    logger.debug("Actions:CommentSystem:fetchAllComments", "↪ called...", {
      orgaId,
      campaignId
    });
    return database
      .fetchAllComments(orgaId, campaignId)
      .then((comments) => {
        if (!comments) {
          return this.failed(true);
        }
        logger.debug("Actions:CommentSystem:fetchAllComments", "Fetched all comments", {
          orgaId,
          campaignId,
          comments
        });
        this.completed(comments);
      })
      .catch(this.failed);
  });
}
